import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
  checkPermisson,
  getTennisMarkets,
} from '../../../../selectors/common';
import { selectorTennisMarketMargins } from '../../../../selectors/marketMargins';
import MarketMargins from '..';
import { PERMISSIONS } from '../../../../constants';
import { aGetTennisMarketMargins, aUpdateTennisMarketMarginsRequest } from '../../../../reducers';
import { aClearTennisMarketMargins } from '../../../../reducers/marketMargins';

const mapToProps = (state) => ({
  checkPermisson: (payload) => checkPermisson(state, payload),
  marketMargins: selectorTennisMarketMargins(state),
  allMarkets: getTennisMarkets(state),
});

const actionsToProps = (dispatch) => ({
  getMargins: (payload) => dispatch(aGetTennisMarketMargins(payload)),
  updateMarketMargins: (payload) => dispatch(aUpdateTennisMarketMarginsRequest(payload)),
  clearMarketMargins: (payload) => dispatch(aClearTennisMarketMargins(payload)),

});

const MarketMarginsTennis = (props) => {
  const navigate = useNavigate();
  return (<MarketMargins
    navigate={navigate}
    getMargins={props.getMargins}
    clearMarketMargins={props.clearMarketMargins}
    marketMargins={props.marketMargins}
    allMarkets={props.allMarkets}
    updateMarketMargins={props.updateMarketMargins}
    hasPermissionToUpdate={props.checkPermisson(PERMISSIONS.TENNIS_MARKET_MARGINS_UPDATE)}
    isTennis
  />
  );
};

export default connect(mapToProps, actionsToProps)(MarketMarginsTennis);
